module.exports = __webpack_public_path__ + "static/img/tab2Big.e89495d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/tab2Big.png
// module id = Cc9l
// module chunks = 1